import { useEffect } from 'react';

const ShopifyDocument = () => {
    useEffect(() => {
        // Redirect to actual static file URL
        window.location.href = '/plugins/plugin/shopify-installation-document.pdf';
    }, []);
    return <>
    </>;
};

export default ShopifyDocument;
